var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZkPhysics(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "600px",
    viewBox: "0 0 800 600",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Zero Knowledge Physics Engine") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 300,
    r: 100,
    fill: "#E8F5E9",
    stroke: "#4CAF50",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 295,
    fontFamily: "Arial",
    fontSize: 20,
    fill: "#4CAF50",
    textAnchor: "middle"
  }, "Physics Core"), /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 325,
    fontFamily: "Arial",
    fontSize: 16,
    fill: "#4CAF50",
    textAnchor: "middle"
  }, "Simulation Engine"), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 150,
    width: 150,
    height: 80,
    rx: 10,
    fill: "#E3F2FD",
    stroke: "#2196F3",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 255,
    y: 195,
    fontFamily: "Arial",
    fontSize: 16,
    fill: "#2196F3",
    textAnchor: "middle"
  }, "Formal Verification"), /*#__PURE__*/React.createElement("rect", {
    x: 470,
    y: 150,
    width: 150,
    height: 80,
    rx: 10,
    fill: "#FFEBEE",
    stroke: "#F44336",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 545,
    y: 195,
    fontFamily: "Arial",
    fontSize: 16,
    fill: "#F44336",
    textAnchor: "middle"
  }, "Military-Grade Precision"), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 370,
    width: 150,
    height: 80,
    rx: 10,
    fill: "#FFF3E0",
    stroke: "#FF9800",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 255,
    y: 415,
    fontFamily: "Arial",
    fontSize: 16,
    fill: "#FF9800",
    textAnchor: "middle"
  }, "Real-Time Scheduler"), /*#__PURE__*/React.createElement("rect", {
    x: 470,
    y: 370,
    width: 150,
    height: 80,
    rx: 10,
    fill: "#F3E5F5",
    stroke: "#9C27B0",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 545,
    y: 415,
    fontFamily: "Arial",
    fontSize: 16,
    fill: "#9C27B0",
    textAnchor: "middle"
  }, "Cryptographic State"), /*#__PURE__*/React.createElement("line", {
    x1: 255,
    y1: 230,
    x2: 320,
    y2: 280,
    stroke: "#333",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 545,
    y1: 230,
    x2: 480,
    y2: 280,
    stroke: "#333",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 255,
    y1: 370,
    x2: 320,
    y2: 320,
    stroke: "#333",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 545,
    y1: 370,
    x2: 480,
    y2: 320,
    stroke: "#333",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "physics-objects"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 370,
    cy: 280,
    r: 10,
    fill: "#E91E63",
    stroke: "#333",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 410,
    cy: 290,
    r: 8,
    fill: "#3F51B5",
    stroke: "#333",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 430,
    cy: 310,
    r: 12,
    fill: "#009688",
    stroke: "#333",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 390,
    cy: 320,
    r: 7,
    fill: "#FFC107",
    stroke: "#333",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 370,
    y1: 280,
    x2: 390,
    y2: 290,
    stroke: "#333",
    strokeWidth: 1,
    strokeDasharray: "2,2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 430,
    y1: 310,
    x2: 410,
    y2: 300,
    stroke: "#333",
    strokeWidth: 1,
    strokeDasharray: "2,2"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 260,
    width: 120,
    height: 80,
    rx: 5,
    fill: "#E0F7FA",
    stroke: "#00BCD4",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 160,
    y: 290,
    fontFamily: "Arial",
    fontSize: 14,
    fill: "#00BCD4",
    textAnchor: "middle"
  }, "Binary Space"), /*#__PURE__*/React.createElement("text", {
    x: 160,
    y: 310,
    fontFamily: "Arial",
    fontSize: 14,
    fill: "#00BCD4",
    textAnchor: "middle"
  }, "Partitioning"), /*#__PURE__*/React.createElement("rect", {
    x: 580,
    y: 260,
    width: 120,
    height: 80,
    rx: 5,
    fill: "#F5F5F5",
    stroke: "#9E9E9E",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 640,
    y: 290,
    fontFamily: "Arial",
    fontSize: 14,
    fill: "#9E9E9E",
    textAnchor: "middle"
  }, "ZK Proof"), /*#__PURE__*/React.createElement("text", {
    x: 640,
    y: 310,
    fontFamily: "Arial",
    fontSize: 14,
    fill: "#9E9E9E",
    textAnchor: "middle"
  }, "System"), /*#__PURE__*/React.createElement("line", {
    x1: 220,
    y1: 300,
    x2: 300,
    y2: 300,
    stroke: "#333",
    strokeWidth: 1,
    strokeDasharray: "3,3"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 300,
    x2: 580,
    y2: 300,
    stroke: "#333",
    strokeWidth: 1,
    strokeDasharray: "3,3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 80,
    width: 300,
    height: 40,
    rx: 20,
    fill: "#DCEDC8",
    stroke: "#8BC34A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 105,
    fontFamily: "Arial",
    fontSize: 16,
    fill: "#8BC34A",
    textAnchor: "middle"
  }, "Energy Efficiency Optimization (97%)"), /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 480,
    width: 300,
    height: 40,
    rx: 20,
    fill: "#FFE0B2",
    stroke: "#FF9800",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 505,
    fontFamily: "Arial",
    fontSize: 16,
    fill: "#FF9800",
    textAnchor: "middle"
  }, "Fault Injection System"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZkPhysics);
export default __webpack_public_path__ + "static/media/zk-physics.68db3592a5ccae106d07b7dbe586174d.svg";
export { ForwardRef as ReactComponent };